import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, Button } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

import { useSectionActionPlan } from '../context';
import { Text } from '@/components/Typography';
import { Label } from '../components';
import { TaskTitle } from '../Fields';
import type { Task } from './types';
import * as S from './styles';

const { useWatch } = Form;

interface TasksProps {
	tasks: Task[];
	onAdd(): void;
	onRemove(taskIndex: number): void;
}

export function Tasks({ tasks, onAdd, onRemove }: Readonly<TasksProps>) {
	const { form_field_name: formFieldName } = useSectionActionPlan();

	const taskTitle = useWatch([...formFieldName, 'task', 'title']);

	return (
		<Row gutter={[0, 5]}>
			<Label>{I18n.get('Tasks')}</Label>
			<Col span={24} style={{ marginBottom: 40 }}>
				<Row justify="space-between" gutter={[15, 0]}>
					<Col lg={22} xl={22} xxl={23}>
						<TaskTitle />
					</Col>
					<Col lg={2} xl={2} xxl={1} style={{ display: 'flex', justifyContent: 'center' }}>
						<Button
							type="primary"
							shape="circle"
							onClick={onAdd}
							icon={<PlusOutlined />}
							disabled={!taskTitle}
						/>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row gutter={[0, 10]}>
					{tasks.map((task, index) => {
						return (
							<Col span={24} key={task.id}>
								<S.TaskItem>
									<Col lg={22} xxl={23}>
										<Text>{task.description}</Text>
									</Col>
									<Col lg={2} xxl={1}>
										<S.DeleteButton onClick={() => onRemove(index)}>
											<DeleteOutlined style={{ color: '#E74150' }} />
										</S.DeleteButton>
									</Col>
								</S.TaskItem>
							</Col>
						);
					})}
				</Row>
			</Col>
		</Row>
	);
}
